import { render, staticRenderFns } from "./EmbedLayout.vue?vue&type=template&id=7278baac&scoped=true"
import script from "./EmbedLayout.vue?vue&type=script&lang=js"
export * from "./EmbedLayout.vue?vue&type=script&lang=js"
import style0 from "./EmbedLayout.vue?vue&type=style&index=0&id=7278baac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278baac",
  null
  
)

export default component.exports